<template>
  <div class="accountSettings" :class="{ 'pa-5': xsOrsm, 'pa-6': breakpointMd, 'pa-4': xlOrlg }">
    <div class="accountSettings-body--title fw-600" :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }">
      Profile Settings
    </div>
    <div class="accountSettings-body--form pt-3">
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="10">
            <TextField
              v-model="userName"
              rules="required|max:50"
              :loading="isAccountSettingsFormLoading"
              label="Your Name"
              showIcons
              :showOnlyErrorIcons="true"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="2">
            <v-btn
              color="primary"
              large
              class="white--text my-2 d-flex justify-bottom"
              :loading="isAccountSettingsFormLoading"
              @click="passes(updateProfileSettings)"
            >
              <span class="font-weight-bold fs-15">Update</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-2"></v-divider>
      </ValidationObserver>
      <v-row class="">
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="12">
          <v-btn
            width="140"
            color="primary"
            large
            class="white--text my-3"
            :loading="isAccountSettingsFormLoading"
            @click="forgotPassword"
          >
            <span class="font-weight-bold fs-15">Click Here</span>
          </v-btn>
          <span class="mx-1 fs-14"
            >to Reset Your Password. A password reset token will be sent to your email and you will be logged out in 3
            seconds.</span
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import { SNACKBAR } from "@/store/actionTypes";
import { FORGOT_PASSWORD } from "@/modules/AuthModule/store/actionTypes";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import { UPDATE_USER_NAME } from "@/modules/AuthModule/store/mutationTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
import Auth from "@/packages/auth";
export default {
  name: "AccountSettings",
  components: {
    ValidationObserver,
    TextField
  },
  data() {
    return {
      isAccountSettingsFormLoading: false
    };
  },
  mixins: [commonMethodsMixin],
  methods: {
    updateProfileSettings() {
      this.isAccountSettingsFormLoading = true;
      const formData = {
        name: this.userName
      };
      this.$store
        .dispatch(AT.UPDATE_USER_NAME, formData)
        .then(res => {
          if (res && res.data) {
            this.$store.dispatch(SNACKBAR, {
              color: "success",
              text: "Username updated"
            });
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isAccountSettingsFormLoading = false;
        });
    },
    forgotPassword() {
      this.isAccountSettingsFormLoading = true;
      this.$store
        .dispatch(FORGOT_PASSWORD, {
          email: this.$store.state.AuthModuleStore.user.email
        })
        .then(res => {
          if (res && res.message === "success") {
            this.$store.dispatch(SNACKBAR, {
              color: "success",
              text: "Email has been sent. You will be logged out in few seconds."
            });
            setTimeout(() => {
              Auth.logout();
              this.$router.push({ name: "auth.login" });
            }, 3000);
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isAccountSettingsFormLoading = false;
        });
    }
  },
  computed: {
    userName: {
      get() {
        return this.$store.getters.user.name;
      },
      set(value) {
        this.$store.commit(UPDATE_USER_NAME, { value });
      }
    }
  }
};
</script>
